/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { PlatformDescriptionStatusDTOLastRun } from "./PlatformDescriptionStatusDTOLastRun";
import {
  PlatformDescriptionStatusDTOLastRunFromJSON,
  PlatformDescriptionStatusDTOLastRunFromJSONTyped,
  PlatformDescriptionStatusDTOLastRunToJSON
} from "./PlatformDescriptionStatusDTOLastRun";

/**
 *
 * @export
 * @interface PlatformDescriptionStatusDTO
 */
export interface PlatformDescriptionStatusDTO {
  /**
   *
   * @type {number}
   * @memberof PlatformDescriptionStatusDTO
   */
  platformId: number;
  /**
   *
   * @type {string}
   * @memberof PlatformDescriptionStatusDTO
   */
  name: string;
  /**
   *
   * @type {boolean}
   * @memberof PlatformDescriptionStatusDTO
   */
  productDescriptionEnabled: boolean;
  /**
   *
   * @type {PlatformDescriptionStatusDTOLastRun}
   * @memberof PlatformDescriptionStatusDTO
   */
  lastRun?: PlatformDescriptionStatusDTOLastRun | null;
  /**
   * True when the newest run for this platform has status RUNNING.
   * @type {boolean}
   * @memberof PlatformDescriptionStatusDTO
   */
  isRunning: boolean;
}

/**
 * Check if a given object implements the PlatformDescriptionStatusDTO interface.
 */
export function instanceOfPlatformDescriptionStatusDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "platformId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "productDescriptionEnabled" in value;
  isInstance = isInstance && "isRunning" in value;

  return isInstance;
}

export function PlatformDescriptionStatusDTOFromJSON(json: any): PlatformDescriptionStatusDTO {
  return PlatformDescriptionStatusDTOFromJSONTyped(json, false);
}

export function PlatformDescriptionStatusDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PlatformDescriptionStatusDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    platformId: json["platformId"],
    name: json["name"],
    productDescriptionEnabled: json["productDescriptionEnabled"],
    lastRun: !exists(json, "lastRun") ? undefined : PlatformDescriptionStatusDTOLastRunFromJSON(json["lastRun"]),
    isRunning: json["isRunning"]
  };
}

export function PlatformDescriptionStatusDTOToJSON(value?: PlatformDescriptionStatusDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    platformId: value.platformId,
    name: value.name,
    productDescriptionEnabled: value.productDescriptionEnabled,
    lastRun: PlatformDescriptionStatusDTOLastRunToJSON(value.lastRun),
    isRunning: value.isRunning
  };
}
